import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const CommentMessageBubbleIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={26}
        height={24}
        viewBox="0 0 26 24"
        className="Icon comment-message-bubble"
        {...props}
    >
        <defs>
            <filter
                id="CommentMessageBubbleIcon__a"
                width="116.7%"
                height="122.2%"
                x="-8.3%"
                y="-5.6%"
                filterUnits="objectBoundingBox"
            >
                <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={1.5} />
                <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    values="0 0 0 0 0.196078431 0 0 0 0 0.231372549 0 0 0 0 0.290196078 0 0 0 0.3 0"
                />
            </filter>
            <path
                id="CommentMessageBubbleIcon__b"
                fillRule="evenodd"
                d="M21 1a4 4 0 0 1 4 4v10.347a4 4 0 0 1-4 4h-5.261L13.5 22.333a.625.625 0 0 1-.058.067l-.067.058a.625.625 0 0 1-.875-.125l-2.239-2.986H5a4 4 0 0 1-4-4V5a4 4 0 0 1 4-4h16z"
            />
        </defs>
        <g fill="none">
            <use xlinkHref="#CommentMessageBubbleIcon__b" fill="#000" filter="url(#CommentMessageBubbleIcon__a)" />
            <use
                xlinkHref="#CommentMessageBubbleIcon__b"
                fill="#2F63F7"
                stroke="#FFF"
                strokeLinejoin="square"
                strokeWidth={2}
                className="shape"
            />
        </g>
    </svg>
);
const Memo = memo(CommentMessageBubbleIcon);
export default Memo;
